var _path, _rect, _rect2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCxTeamActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 21H21V52H38.687L52 38.0023V21Z",
    fill: "#1565D8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 31,
    transform: "matrix(-1 0 0 1 21 21)",
    fill: "#1565D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 21,
    width: 52,
    height: 21,
    transform: "rotate(-180 52 21)",
    fill: "#1565D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M26 34.5H24V33H26V34.5ZM26 32H24C24 30.5 21.5 29 21.5 27C21.5 25.07 23.07 23.5 25 23.5C26.93 23.5 28.5 25.07 28.5 27C28.5 29 26 30.5 26 32Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22H20C18.9 22 18 22.9 18 24V34C18 35.1 18.9 36 20 36H30C31.1 36 32 35.1 32 34V24C32 22.9 31.1 22 30 22ZM26 34.5H24V33H26V34.5ZM26 32H24C24 30.5 21.5 29 21.5 27C21.5 25.07 23.07 23.5 25 23.5C26.93 23.5 28.5 25.07 28.5 27C28.5 29 26 30.5 26 32ZM31 20.5H19C19 19.67 19.67 19 20.5 19H29.5C30.33 19 31 19.67 31 20.5ZM30 17.5H20C20 16.67 20.67 16 21.5 16H28.5C29.33 16 30 16.67 30 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxTeamActive);
export default __webpack_public_path__ + "static/media/cx-team-active.c0550a7795065c474a4c7aa64955e7b5.svg";
export { ForwardRef as ReactComponent };